module.exports = __webpack_public_path__ + "media/video_assetowning_brokeragebanner.3dbada6f.mp4";